<script setup>
import { trans } from '@elements/translation';
import { URL_SUBSCRIPTION } from '@elements/tools/routes/routes';

const props = defineProps({
  subscriptionId: {
    type: Number,
    required: true,
  },
});
</script>

<template>
  <li>
    <a :href="`${URL_SUBSCRIPTION}/${props.subscriptionId}`">
      {{ trans('gestion.invoices.subscription') }}
    </a>
  </li>
</template>
